export default interface IStorageManageModel {
    start(): void;
    stop(): void;
}
